import { render } from "./TitleBox.vue?vue&type=template&id=443f1885&scoped=true"
import script from "./TitleBox.vue?vue&type=script&lang=js"
export * from "./TitleBox.vue?vue&type=script&lang=js"

import "./TitleBox.vue?vue&type=style&index=0&id=443f1885&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443f1885"]])

export default __exports__